import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M13 11a3.19 3.19 0 003 3 3.19 3.19 0 003-3z"/><path d="M27 28h-1.17c-.67-4.48-3.27-10.5-5.8-12 2.53-1.5 5.13-7.52 5.8-12H27a1 1 0 000-2H5a1 1 0 000 2h1.17C6.84 8.48 9.44 14.5 12 16c-2.53 1.5-5.13 7.52-5.8 12H5a1 1 0 000 2h22a1 1 0 000-2zm-5 0c0-3-4.5-7-6-7s-6 4-6 7H8.18c.67-4 3-9.2 4.81-10.28a2 2 0 000-3.44C11.17 13.2 8.85 8 8.18 4h15.64c-.67 4-3 9.2-4.81 10.28a2 2 0 000 3.44C20.83 18.8 23.15 24 23.82 28z"/>';
export var WaitingOutlineSVG = function WaitingOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
WaitingOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(WaitingOutlineSVG);